/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */
import styled from 'styled-components';

export const FallbackImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px 4px 0 0;
`;

type EnrollCardProps = {
  disable: boolean;
  selected: boolean;
  enrollable: boolean;
};

export const EnrollCardContainer = styled.div<EnrollCardProps>`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  cursor: pointer;

  margin: 0px 10px 0px 10px;
  height: 80px;
  border-radius: 4px;
  background: ${props => (props.disable ? '#DADADD' : '#fff')};
  opacity: ${props => (props.disable ? '0.5' : '1')};
  box-shadow: 0px 5px 20px #00000029;
  outline: ${props => (props.selected && props.enrollable ? '3px solid #2DCAFC' : '')};
`;

export const CardImgContainer = styled.div`
  display: flex;
  flex-grow: 2;
  min-height: 136px;
  border-radius: 4px 4px 0 0;
  justify-content: flex-end;
`;

export const ImgBox = styled.div`
  /* now a container for the image */
  width: 100%;
  height: 100%;
  display: inline-block; /* shrink wrap to image */
  overflow: hidden; /* hide the excess */
`;

export const CardContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
  padding: 0px 0px 10px 10px;
  border-radius: 0px 0px 4px 4px;
`;

export const CardContentTitle = styled.p`
  font-size: 18px;
  color: #1c1b3a;
  font-weight: 600;
  margin: 3px 0px 0px 0px;
  align-self: center;
  text-align: center;
  max-width: 80%;
`;

export const CardContentSubtitle = styled.p`
  margin: 0;
  font-size: 16px;
  color: #1c1b3a;
  font-weight: 600;
  align-self: center;
  text-align: center;
`;

export const CardContentFee = styled.p`
  margin: 0;
  font-size: 16px;
  color: #1c1b3a;
  font-weight: 600;
  margin-top: 10px;
  align-self: center;
`;

export const CardContentCoverage = styled.p`
  margin: 0;
  font-size: 14px;
  color: #1c1b3a;
  font-weight: 600;
  align-self: center;
`;

export const NotAvailableBenefit = styled.div`
  position: absolute;
  width: 6%;
  margin-top: 5px;
  margin-left: 250px;
  height: 29px;
  text-align: center;
  background-color: red;
  padding: 0%;
  border-radius: 30px;
  border: 1px white solid;
  z-index: 2;
`;

export const NotAvailableText = styled.div`
  font-weight: 400;
  color: white;
  margin-top: 11%;
`;

export const NotAvailableBalloon = styled.div`
  background: white;
  font-size: 11pt;
  position: fixed;
  margin-top: -85px;
  height: 100px;
  width: 250px;
  transform: translateX(-90%);
  z-index: 2;
`;
